// import { useState }           from 'react';

function usePrivacyPage(refs) {
    
    function handleScrollTo(name) {
        return () => {
            refs[name].current.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }
    }

    return {
        handleScrollTo
    };
}

export default usePrivacyPage;
